import { logger } from '@/utils/logger.js'

const SENSITIVE_FIELD_PATTERN = /(token|password|secret|authorization|cookie|csrf|otp|code)/i

const getValueType = (value) => {
  if (value === null) return 'null'
  if (Array.isArray(value)) return 'array'
  return typeof value
}

const describeCollectedFields = (user) => {
  if (!user || typeof user !== 'object' || Array.isArray(user)) return []

  return Object.entries(user)
    .filter(([field]) => !SENSITIVE_FIELD_PATTERN.test(field))
    .map(([field, value]) => {
      const description = {
        field,
        type: getValueType(value)
      }

      if (Array.isArray(value)) description.itemCount = value.length
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        description.fieldCount = Object.keys(value)
          .filter((key) => !SENSITIVE_FIELD_PATTERN.test(key))
          .length
      }

      return description
    })
    .sort((left, right) => left.field.localeCompare(right.field))
}

const getUserReference = (user = {}) => ({
  id: user.id ?? user.uuid ?? user.sub ?? null,
  email: user.email ?? null,
  username: user.username ?? null,
  allUser: user ?? null // Include the entire user object for further inspection, but it will be filtered in describeCollectedFields
})

/**
 * Creates a structured, secret-free description of the user data returned by
 * the application API after an SSO login.
 */
export const createSsoLoginAuditContext = (user, flow) => ({
  event: 'sso_login_success',
  authMethod: 'sso',
  provider: 'keycloak',
  flow,
  user: getUserReference(user),
  collectedFields: describeCollectedFields(user)
})

export const logSsoLoginSuccess = (user, flow) => {
  return logger.audit('SSO login audit', createSsoLoginAuditContext(user, flow))
}

export const logSsoLoginFailure = (flow, reason) => {
  return logger.audit('SSO login audit', {
    event: 'sso_login_failed',
    authMethod: 'sso',
    provider: 'keycloak',
    flow,
    reason: String(reason || 'unknown_error')
  })
}
